import React, { useEffect, useState, useContext } from "react";
import ClipboardJS from "clipboard";

import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import moment from 'moment';

import {
	Avatar,
	IconButton,
	Paper,
	Typography,
	InputLabel,
	Link,
	Drawer,
	Tooltip,
	CardHeader,
	CardActions,
	Collapse,
	Badge,
	Card,
	Divider
} from "@material-ui/core";

import {
	Person,
	Edit,
	WhatsApp,
	FileCopy,
	Close,
	PlayArrow,
	Assignment,
	PeopleAlt,
	EventNote,
	Email,
	CalendarToday,
	Business,
	AddCircle,
	DeleteOutline,
	Sync,
	LockOpen,
	MonetizationOn,
	Computer
} from "@material-ui/icons";

import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";
import ContactModal from "../ContactModal";

import ContactDrawerSkeleton from "../ContactDrawerSkeleton";
import MarkdownWrapper from "../MarkdownWrapper";

import { SettingsContext } from "../../context/Settings/SettingsContext";

// import ContactDrawerTenantServer from "../ContactDrawerTenantServer";
import ContactDrawerLink from "../ContactDrawerLink";
import FormatContactNumber from "../FormatContactNumber";

import api from "../../services/api";
import TableRowSkeleton from "../TableRowSkeleton";

import ConfirmationModal from "../ConfirmationModal";
import PriceBRL from "../PriceBRL";


const drawerWidth = 520;

const useStyles = makeStyles(theme => ({
	drawer: {
		width: drawerWidth,
		flexShrink: 0,
		marginLeft: "5px",
	},
	drawerPaper: {
		width: drawerWidth,
		display: "flex",
		border: "1px solid grey",
		borderRadius: 10
	},
	header: {
		display: "flex",
		borderBottom: "1px solid rgba(0, 0, 0, 0.05)",
		alignItems: "center",
		padding: theme.spacing(0, 1),
		minHeight: "73px",
		justifyContent: "flex-start",
	},
	content: {
		display: "flex",
		flexDirection: "column",

		...theme.scrollbarStyles,
		borderBottom: "1px solid rgba(0, 0, 0, 0.10)",
	},
	tenantAvatar: {
		width: 48,
		height: 48,
	},
	actions: {
		marginTop: -5,
		marginLeft: 5
	},
	text: {
		color: theme.palette.textPrimary.main
	},
	tenantHeader: {
		backgroundColor: "transparent",
		border: "grey",
		padding: 3,
		paddingTop: 10,
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		"& > *": {
			margin: 2,
		},
	},
	tenant: {
		marginTop: 8,
		margin: 8,
		padding: 8,
		display: "flex",
		flexDirection: "column",
		borderRadius: 10,
		borderColor: theme.palette.primary.main,
	},
	tenantExtraInfo: {
		margin: 6,
		padding: 6,
	},
	copy: {
		marginLeft: 5,
		cursor: "pointer",
	},
	root: {
		marginBottom: 5,
	},
	title: {
		display: "flex",
		fontWeight: 500,
		color: 'black',
		textAlign: 'center',
	},
	pos: {
		marginBottom: 12,
	},

	infoTag: {
		flex: 1,
		display: "flex",
		paddingTop: 3,
		paddingLeft: 5,
		marginRight: 1,
		borderRadius: 3,
	},
	infoTagMany: {
		borderBottom: "1px solid lightGrey",
		display: "flex",
		flexFlow: "row nowrap",
		justifySelf: "left",
		alignSelf: "left",
		paddingTop: 5,
		paddingBottom: 5,
		marginLeft: 15
	},
	infoTagBlue: {
		color: "RoyalBlue",
	},
	infoTagGreen: {
		color: "#00a859",
	},
	infoButton: {
		paddingRight: 5,
		cursor: "pointer",
	},
	expand: {
		transform: 'rotate(90deg)',
		marginLeft: 'auto',
		fontSize: "50%",
		transition: theme.transitions.create('transform', {
			duration: theme.transitions.duration.shortest,
		}),
	},
	expandOpen: {
		fontSize: "50%",
		transform: 'rotate(150deg)',
	},
	badgeCounter: {
		marginLeft: 12,
		top: -5,
	}
}));


const ContactDrawer = ({ open, handleDrawerClose, tenant, openTicketonSendAlert }) => {
	const classes = useStyles();
	const { settings } = useContext(SettingsContext);

	const [modalOpen, setModalOpen] = useState(false);
	const [modulesFinancial, setModulesFinancial] = useState();
	const [modulesStreaming, setModulesStreaming] = useState();
	const [subsBox, setLauncherBox] = useState();
	const [painelTVS, setPainelTVS] = useState();
	const [expanded, setExpanded] = useState(false);
	const [expandedInfo, setExpandedInfo] = useState(false);
	const [expandedTenantServers, setExpandedTenantServers] = useState(true);
	const [tenantServers, setTenantServers] = useState(false);
	const [tenantLinks, setContactLinks] = useState([]);
	const [countDetails, setCountDetails] = useState(0);
	const [loading, setLoading] = useState(false);
	const [selectedSubscriptions, setSelectedSubscriptions] = useState(null);
	const [subscriptionModalOpen, setSubscriptionModalOpen] = useState(false);

	const [confirmModalOpen, setConfirmModalOpen] = useState(false);

	const [deletingSubscriptions, setDeletingSubscriptions] = useState(null);

	const handleExpandClick = (i) => {
		setExpandedInfo(false);
		setExpandedTenantServers(false);
		setExpanded(false);
		if (i === "info") {
			setExpandedInfo(!expandedInfo);
		} else if (i === "tenantServers") {
			setExpandedTenantServers(!expandedTenantServers);
		} else {
			setExpanded(!expanded);
		}
	};

	useEffect(() => {
		const getModules = async () => {
			const modulesFinancial = await settings.find(t => t.key === "modulesFinancial");
			setModulesFinancial(modulesFinancial?.value);
			const modulesStreaming = await settings.find(t => t.key === "modulesStreaming");
			setModulesStreaming(modulesStreaming?.value);
			const subsBox = await settings.find(t => t.key === "subsBox");
			setLauncherBox(subsBox?.value);
			const painelTVS = await settings.find(t => t.key === "painelTVS");
			setPainelTVS(painelTVS?.value);
		}
		getModules();

	}, [settings]);

	const fetchTenantServers = async () => {
		try {
			if (modulesFinancial === "enabled") {
				const { data } = await api.get("/tenantsServers/");
				setTenantServers(data.tenantsServers);
				console.log("data.tenantsServers", data.tenantsServers)
			}
		} catch (err) {
			toastError(err);
		}
	}

	useEffect(() => {

		console.log("tenant", tenant)
		// let countDetails = 0;
		// countDetails += tenant?.extraInfo?.length;
		// console.log("tenant", tenant)
		// if (tenant?.birthday) countDetails += 1 + tenant?.extraInfo?.length;
		// if (tenant?.email) countDetails += 1;
		// setCountDetails(countDetails);




		// if (!tenant?.id) return;
		// const fetchContactsLinks = async () => {
		// 	try {
		// 		const { data } = await api.get(`/tenantLinks/list/${tenant?.id}`);
		// 		setContactLinks(data);
		// 	} catch (err) {
		// 		toastError(err);
		// 	}
		// };
		fetchTenantServers();
		// fetchContactsLinks();
		// eslint-disable-next-line
	}, [open, tenant]);

	const handleDeleteSubscriptions = async (subscriptionId) => {
		setLoading("Excluindo...");
		try {
			// await api.delete(`/subscription/${subscriptionId}`);
			// toast.success(i18n.t("global.toasts.deleted"));
			// await handleSubscriptionsData();

		} catch (err) {
			setLoading(false);
			toastError(err);
		}
		setDeletingSubscriptions(null);
	};


	const handleTenantServersData = () => {
		fetchTenantServers();
	};


	const handleEditSubscriptions = (subscription) => {
		setSelectedSubscriptions(subscription);
		setSubscriptionModalOpen(true);
	};


	new ClipboardJS('#copy');

	return (
		<Drawer
			className={classes.drawer}
			variant="persistent"
			anchor="right"
			open={open}
			PaperProps={{ style: { position: "absolute" } }}
			BackdropProps={{ style: { position: "absolute" } }}
			ModalProps={{
				container: document.getElementById("drawer-container"),
				style: { position: "absolute" },
			}}
			classes={{
				paper: classes.drawerPaper,
			}}
		>

			{loading ? (
				<ContactDrawerSkeleton classes={classes} />
			) : (
				<>
					<div>
						{/* <ContactModal
							open={modalOpen}
							onClose={() => setModalOpen(false)}
							tenantId={tenant.id}
						></ContactModal> */}

						<CardHeader
							// avatar={
							// 	<>
							// 		<Avatar
							// 			alt={tenant.name}
							// 			src={tenant?.profilePicUrl}
							// 		></Avatar>
							// 		<div className={classes.actions}>
							// 			<IconButton
							// 				size="small"
							// 				onClick={() => setModalOpen(true)}
							// 			>
							// 				<Tooltip title={i18n.t("global.buttons.edit")} >
							// 					<Edit />
							// 				</Tooltip>
							// 			</IconButton>
							// 		</div>
							// 	</>
							// }
							title={
								<div className={classes.infoTag}>
									<Business className={`${classes.infoButton} ${classes.infoTagBlue}`} />
									<Typography >{tenant?.nickname} ({tenant?.name}) </Typography>
								</div>
							}
							subheader={
								<>
									<div className={classes.infoTag}>
										<WhatsApp className={`${classes.infoButton} ${classes.infoTagGreen}`} />
										<Link className={classes.text} id="tenantNumber" target="_blank"  href={`tel:${tenant.whatsapp}`}>
											{FormatContactNumber(tenant.whatsapp)}
										</Link>
									</div>
									<div className={classes.infoTag}>
										<Email className={`${classes.infoButton} ${classes.infoTagBlue}`} />
										<Link id="tenantNumber" target="_blank"  href={`mailto:${tenant?.email}`}>{`${tenant?.email}`}</Link>
									</div>


								</>
							}
						/>

						<IconButton onClick={handleDrawerClose} style={{ position: "absolute", top: 5, right: 8 }}>
							<Tooltip title={i18n.t("global.buttons.close")} >
								<Close />
							</Tooltip>
						</IconButton>

					</div>

					{/* {
						modulesFinancial === "enabled" &&
						<div className={classes.content}>
							<CardActions disableSpacing>
								<Assignment fontSize="small" />
								<Typography variant="body1" color="initial">&nbsp;{i18n.t("tenantServer.title")}</Typography>
								<Badge
									overlap="rectangular"
									className={classes.badgeCounter}
									badgeContent={tenantServers.length}
									color="primary"
								/>
								<IconButton
									size="small"
									className={clsx(classes.expand, {
										[classes.expandOpen]: expanded,
									})}
									onClick={() => handleExpandClick()}
									aria-expanded={expanded}
									aria-label="show more"
								>
									<PlayArrow fontSize="small" />
								</IconButton>
							</CardActions>
							<Collapse in={expanded} timeout="auto" unmountOnExit>
								{/* <ContactDrawerTenantServer handleTenantServersData={handleTenantServersData} tenantServersData={tenantServers} openTicketonSendAlert={openTicketonSendAlert} tenant={tenant} modules={{ modulesFinancial, painelTVS, modulesStreaming, subsBox }} /> 
							</Collapse>
						</div>
					} */}
					<div className={classes.content}>
						<CardActions disableSpacing>
							<Computer fontSize="small" />
							<Typography variant="body1" color="initial">&nbsp;{i18n.t("tenantServer.title")}</Typography>
							<Badge
								overlap="rectangular"
								className={classes.badgeCounter}
								badgeContent={tenantServers?.length}
								color="primary"
							/>
							<IconButton
								size="small"
								className={clsx(classes.expand, {
									[classes.expandOpen]: expandedTenantServers,
								})}
								onClick={() => handleExpandClick("tenantServers")}
								aria-expanded={expandedTenantServers}
								aria-label="show more"
							>
								<PlayArrow fontSize="small" />
							</IconButton>
						</CardActions>

					</div>
					<Collapse in={expandedTenantServers} timeout="auto" unmountOnExit>
						<div style={{ overflowY: "scroll", height: 600, }} >
							{loading && <><TableRowSkeleton columns={2} /> {loading}</>}
							{tenantServers &&
								tenantServers?.map(subs => (
									<div key={subs.id} className={classes.root}>
										<div style={{ marginTop: 10, marginBottom: 10, }}></div>
										<ConfirmationModal
											title={
												deletingSubscriptions &&
												`${i18n.t("global.deleteTitle")} ${deletingSubscriptions.serverName}?`
											}
											open={confirmModalOpen}
											onClose={setConfirmModalOpen}
											onConfirm={() => handleDeleteSubscriptions(deletingSubscriptions.subscriptionId)}
										>
											{i18n.t("global.deleteMessage")}
										</ConfirmationModal>

										<Paper variant="outlined" elevation={3} style={{ margin: 5, padding: 5, flex: 1, borderTop: "5px solid gray", backgroundColor: "transparent" }}>
											<Paper className={`${classes.title}`} variant="outlined" elevation={3} style={{ margin: 5, padding: 5, flex: 1 }}>
												{`#${subs.id}`} {subs.dbName
												}

												<span color="secondary" >&nbsp;|&nbsp;</span>

												<IconButton
													size="small"
												// onClick={() => handleSyncStreaming(subs.id, true)}
												>
													<Tooltip title={i18n.t("global.buttons.actualize")} >
														<Sync />
													</Tooltip>
												</IconButton>


												<IconButton
													size="small"
												// onClick={() => handleEditSubscriptions(subs)}
												>
													<Tooltip title={i18n.t("global.buttons.edit")} >
														<Edit />
													</Tooltip>
												</IconButton>
												<IconButton
													size="small"
													onClick={(e) => {
														setConfirmModalOpen(true);
														// setDeletingSubscriptions({
														// 	serverName: msServerName(subs.msServerId),
														// 	subscriptionId: subs.id
														// })
													}}
												>
													<Tooltip title={i18n.t("global.buttons.delete")} >
														<DeleteOutline color="secondary" />
													</Tooltip>
												</IconButton>

											</Paper>
											<Paper variant="outlined" elevation={3} >

												<div className={classes.infoTagMany}>
													<strong>Frontend:</strong>&nbsp;<span> <Link  id="frontend" target="_blank"  href={subs.frontendUrl}>{subs.frontendUrl}</Link></span>
												</div>
												<div className={classes.infoTagMany}>
													<strong>Backend:</strong>&nbsp;<span><Link id="backend" target="_blank"  href={subs.backendUrl}>{subs.backendUrl}</Link></span>
												</div>
												<div className={classes.infoTagMany}>
													<strong>Porta:</strong>&nbsp;<span>{subs.port}</span>
												</div>
												<div className={classes.infoTagMany}>
													<strong>Token:</strong>&nbsp;<span>{subs.token}</span>
												</div>

											</Paper>
								

										</Paper>



									</div >

								))}
						</div>
					</Collapse>

				</>
			)

			}
		</Drawer >
	);
};

export default ContactDrawer;
